import axios from "axios";

const axiosInstance = axios.create({
  baseURL: String,
});

/*
axiosInstance.interceptors.response.use((response) => response, (error) => {
    if (error.response && error.response.status === 401)
        return store.dispatch('authenticationFailed')
});
*/
axiosInstance.defaults.baseURL = process.env.VUE_APP_MPT_API_URL;

export default axiosInstance;
